var setUserCountry = function setUserCountry() {
  var countryKey = 'userCountry';
  var currencyKey = 'userCurrency';
  var ttlKey = 'userCountryTTL';
  var ttl = 24 * 60 * 60 * 1000; // 24 h

  var now = Date.now();
  var storedTime = localStorage.getItem(ttlKey);

  // Si no hay TTL o está vencido → vuelve a pedir los datos
  if (!storedTime || now - parseInt(storedTime, 10) > ttl) {
    fetch('https://ipapi.co/json/?key=gTouOdZEGM8W3Si8d7kBvFnRP6DHh3eQYPih7lyeBFystCwLVt').then(function (response) {
      if (!response.ok) throw new Error('Failed to fetch geo data');
      return response.json();
    }).then(function (_ref) {
      var country_name = _ref.country_name,
        currency = _ref.currency;
      if (country_name) {
        localStorage.setItem(countryKey, country_name.trim());
      }
      if (currency) {
        localStorage.setItem(currencyKey, currency.trim());
      }
      localStorage.setItem(ttlKey, now.toString());
      console.log("country: ".concat(country_name, ", currency: ").concat(currency));
    })["catch"](function (error) {
      console.error('Error fetching geo data:', error);
    });
  }
};
export { setUserCountry };